import { useLazyQuery } from '@apollo/client'
import { Download } from '@mui/icons-material'
import { Button } from '@mui/material'
import { GetResumeUrl } from 'recruiter/graphql/documents.gql'

export default function ResumeDownloadButton({
    documentId,
}: {
    documentId: string
}) {
    const [download, { loading }] = useLazyQuery(GetResumeUrl, {
        fetchPolicy: 'network-only',
    })

    const handleClick = async (e: React.MouseEvent) => {
        e.stopPropagation()
        const { data } = await download({ variables: { documentId } })
        if (data?.download?.url) {
            const link = document.createElement('a')
            link.href = data.download.url
            link.target = '_blank'
            link.click()
            link.remove()
        }
    }

    return (
        <Button
            variant="text"
            size="small"
            onClick={handleClick}
            disabled={loading}
        >
            <Download />
        </Button>
    )
}
